const FLOWCHART_HEADER = /^\s*(?:flowchart|graph)\b/;
// A quoted string used directly as a node (`"Grand Mere" --> "9001-Natasha"`): at the start
// of a line, or right after an arrow (optionally with a `|label|`) or `&`. Quoted text inside
// a node shape (`A["x"]`) or an edge label (`A -- "x" --> B`, `-->|"x"|`) is not matched.
const BARE_NODE = /(^\s*|(?:-->|---|==>|===|-\.->|--[xo]|&)(?:\s*\|[^|]*\|)?\s*)"([^"]*)"/g;

/**
 * Give bare quoted flowchart nodes an ID so mermaid can parse them, reusing the same ID
 * for the same label so edges still connect.
 * @param {string} chart
 * @returns {string}
 */
export function normalizeFlowchart(chart) {
  if (!FLOWCHART_HEADER.test(chart)) return chart;

  /** @type {Map<string, string>} */
  const ids = new Map();

  return chart
    .split('\n')
    .map((line, index) => {
      if (index === 0 || line.trim().startsWith('%%')) return line;

      return line.replace(BARE_NODE, (_, prefix, label) => {
        if (!ids.has(label)) ids.set(label, `node${ids.size + 1}`);
        return `${prefix}${ids.get(label)}["${label}"]`;
      });
    })
    .join('\n');
}
